<canvas #canvasElement [width]="width" [height]="height"></canvas>
